import * as React from 'react';
import CTSAReportHeader from "./CTSAReportHeader";
import CompareGroupSelector from "./CompareGroupSelector";
import PublicationsAndPatents from './PublicationsAndPatents';
import { transformTotals } from './CTSAReportHelper';


interface Props {
    comparisonGroup?: string[];
    availableGroup?: string[];
    changeComparisonGroup?();
    displayId?: string;
    CTSASchoolList?: {}[];
    awardTotal?: { KL2: number, K01: number, K08: number, K12: number, K23: number };
    mesh?: {}[];
    patentNumber?: {}[];
    patentSector?: {}[];
    bibs?: {}[];
    journals?: {}[];
}




class ScientificProductivity extends React.Component<Props, {}> {




    render() {

        const { comparisonGroup, awardTotal, mesh, patentNumber, patentSector, bibs, journals, displayId, CTSASchoolList, changeComparisonGroup, availableGroup } = this.props;
        if (awardTotal && comparisonGroup && mesh && patentNumber && patentSector && bibs && journals) {
            return (
                <div className="tabcontents container-fluid" style={{ border: 'none' }}>

                    <CTSAReportHeader compareGroup={comparisonGroup} displayId={displayId} CTSASchoolList={CTSASchoolList} awardTotal={transformTotals(awardTotal)} />
                    <CompareGroupSelector
                        onChange={changeComparisonGroup}
                        selectedGroup={comparisonGroup}
                        awardTotal={transformTotals(awardTotal)}
                        availableGroup={availableGroup}
                    />

                    <PublicationsAndPatents pubComparisonGroup={comparisonGroup} patentNumber={patentNumber} patentSector={patentSector} awardTotal={transformTotals(awardTotal)} bibs={bibs} journals={journals} mesh={mesh} />

                    
                    <img src={require('./CTSA_logo.jpg')} height='50px' style={{ marginTop: '20px' }} />
                </div>


            );
        } else {
            return <i className="fa fa-spinner"></i>;
        }

    }
}
export default ScientificProductivity;



